<template>
    <v-dialog id="terms-dialog" v-model="dialog" scrollable max-width="460px">
        <template v-slot:activator="{ on, attrs }">
            <small v-bind="attrs" v-on="on">{{ title }}</small>
        </template>
        <v-card :style="fontStyle">
            <v-card-title>
                {{ title }}
            </v-card-title>

            <v-card-text class="pb-0">
                <div v-html="terms" class="ql-editor"></div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="darken-1" text @click="dialog = false">
                    {{ $t("close") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import fontMixin from "@/mixins/fontMixin.js";

export default {
    name: "TermsDialog",
    props: {
        title: String,
        terms: String,
    },
    data() {
        return {
            dialog: false,
        };
    },
    mixins: [fontMixin],
    methods: {
        open() {
            this.dialog = true;
        },
    },
};
</script>
